function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { AvGroup } from "availity-reactstrap-validation";
import TmLabel from "./components/TmLabel";
import TmFeedback from "./components/TmFeedback";
import TmHelpMessage from "./components/TmHelpMessage";
import { InputGroup, InputGroupAddon } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/pro-regular-svg-icons";
import { Button } from "../general/Buttons";
import { connect } from 'react-redux';
import styled from "styled-components";
const StyledFormControl = styled.div`
  cursor: pointer;
  height: auto !important;
`;

class TmToggleEditInput extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      const {
        value,
        resourceModal,
        afterChange,
        toggleModal,
        components,
        ...config
      } = this.props;
      return /*#__PURE__*/React.createElement(AvGroup, null, /*#__PURE__*/React.createElement(TmLabel, _extends({
        className: 'no-error-label',
        value: value
      }, config)), /*#__PURE__*/React.createElement(InputGroup, {
        cypress: this.props.cypress
      }, /*#__PURE__*/React.createElement(InputGroupAddon, {
        addonType: "prepend"
      }, /*#__PURE__*/React.createElement(Button, {
        color: 'info',
        size: 'sm',
        onClick: toggleModal,
        type: "button",
        cypress: 'toggleEdit'
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faEdit
      })), resourceModal), /*#__PURE__*/React.createElement(StyledFormControl, {
        className: 'form-control',
        onClick: toggleModal
      }, this.props.value)), /*#__PURE__*/React.createElement(TmFeedback, config), /*#__PURE__*/React.createElement(TmHelpMessage, config));
    });
  }

}

function mapStateToProps(state, ownProps) {
  return {};
}

export default connect(mapStateToProps, {})(TmToggleEditInput);